import classNames from "classnames"
import { Icon } from "../Icon"
import { IconButton } from "../IconButton"
import {
  START_BAR_BG_VARIATION,
  CONTAINER_BG_VARIATION,
  BORDER_VARIATION,
  ICON_COLOUR_VARIATION,
  ICON_NAME_VARIATION,
} from "./constants"
import {
  CalloutHeading,
  CalloutContent,
  CalloutActions,
  CalloutActionLink,
  CalloutActionButton,
} from "./utils"
import type { CalloutProps } from "./types"
import { CalloutContext } from "./CalloutContext"

export function Callout({
  variation = "success",
  closeLabel = "Close",
  children,
  illustrationSrc,
  illustrationAlt = "",
  onRequestClose,
}: CalloutProps) {
  return (
    <CalloutContext.Provider value={{ variation }}>
      <div
        role="status"
        className={classNames(
          "overflow-hidden rounded-md border",
          BORDER_VARIATION[variation],
          CONTAINER_BG_VARIATION[variation],
        )}
      >
        <div className="flex gap-3 py-4 pr-3">
          <span
            data-testid="callout-border"
            className={classNames("-my-4 w-2", START_BAR_BG_VARIATION[variation])}
          />
          <div className="flex w-full gap-3">
            <Icon
              name={ICON_NAME_VARIATION[variation]}
              className={classNames(ICON_COLOUR_VARIATION[variation], "shrink-0")}
              size="sm"
            />
            <div>{children}</div>
            {illustrationSrc && (
              <img
                className="ml-auto hidden max-w-[120px] object-contain md:block"
                src={illustrationSrc}
                alt={illustrationAlt}
              />
            )}
          </div>
          {onRequestClose && (
            <IconButton
              type="button"
              aria-label={closeLabel}
              iconName="Times"
              variation="borderless"
              size="sm"
              onClick={onRequestClose}
            />
          )}
        </div>
      </div>
    </CalloutContext.Provider>
  )
}

Callout.Heading = CalloutHeading
Callout.Content = CalloutContent
Callout.Actions = CalloutActions
Callout.ActionButton = CalloutActionButton
Callout.ActionLink = CalloutActionLink
